// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementOnImpressionsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.avg_engagement_on_impressions_history',
    margin: { left: -20, right: 25 },
    disableGraphData: ['count_posts'],
    name: {
        date: 'date',
        value: 'chart.pinterest.avg_engagement_on_impressions_history_name'
    },
    id: 'average_engagement_on_impressions_history',
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.pinterest.tooltip_avg_engagement_on_impressions_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
